// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatGroups_tabs__lDQgp {
  height: 35px !important;
  min-height: 35px !important;
  padding: 0 11px;
  border-bottom: 1px solid #E2E2E2;
}

.ChatGroups_item__XKvg0 {
  height: 35px !important;
  min-height: auto !important;
  padding: 0 10px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 16px !important;
  text-align: center !important;
  min-width: 60px !important;
  text-transform: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ChatGroups/ChatGroups.module.scss"],"names":[],"mappings":"AAGA;EACE,uBAAA;EACA,2BAAA;EACA,eAAA;EACA,gCAAA;AAFF;;AAKA;EACE,uBAAA;EACA,2BAAA;EACA,0BAAA;EAEA,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,+BAAA;AAHF","sourcesContent":["$height: 35px;\n\n\n.tabs {\n  height: $height !important;\n  min-height: $height !important;\n  padding: 0 11px;\n  border-bottom: 1px solid #E2E2E2;\n}\n\n.item {\n  height: $height !important;\n  min-height: auto !important;\n  padding: 0 10px !important;\n\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  line-height: 16px !important;\n  text-align: center !important;\n  min-width: 60px !important;\n  text-transform: none !important;\n}\n\n.indicator {\n  //bottom: -1px;\n  //z-index: 100;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `ChatGroups_tabs__lDQgp`,
	"item": `ChatGroups_item__XKvg0`
};
export default ___CSS_LOADER_EXPORT___;
